import {actions as A} from '../constants/actions';

const defaultState = {
  list: null,
  page: 0,
  totalPages: 0,
  totalResultCount: 0,
  loading: false,
  error: false,
  errorMessage: null
};

export default (state = defaultState, {type, payload}) => {
  switch (type) {
    case A.GET_STEP_9_GIRD_FIRM_DATA:
      return {...state, loading: true, error: false, errorMessage: null};

    case A.GET_STEP_9_GIRD_FIRM_DATA_SUCCESS:
      const {list, totalPages, totalResultCount} = payload;
      return {...state, loading: false, error: false, errorMessage: null, list, totalPages, totalResultCount};

    case A.SET_STEP_9_GIRD_FIRM_DATA_PAGE:
      const {page} = payload;
      return {...state, loading: false, error: false, errorMessage: null, page};

    case A.GET_STEP_9_GIRD_FIRM_DATA_FAILURE:
      return {...state, loading: false, error: true, errorMessage: payload};

    case A.CLEAR_INSPECTION:
      return {...defaultState};

    default:
      return state;
  }
}

